import { prepareRequest } from "../../index.js";
import { setParamsToURL } from "../../index.js"
import {COLLECTION_API_URL_LIST} from "@/services/routes/collection";
import  store  from '../../../state/store';

async function getAllCollections(params, body, urlSegments) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(COLLECTION_API_URL_LIST.COLLECTION_GET_ALL,params,urlSegments),
        post: body
    }
    return prepareRequest(config,request,true);
}
async function getSingleCollection(params, body, urlSegments) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "GET",
        url: setParamsToURL(COLLECTION_API_URL_LIST.COLLECTION_GET_SINGLE,params,urlSegments),
        post: body
    }
    return prepareRequest(config,request,true);
}
async function addCollection(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(COLLECTION_API_URL_LIST.COLLECTION_ADD,params),
        post: body
    }
    return prepareRequest(config,request,true);
}
async function updateCollection(params, body) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(COLLECTION_API_URL_LIST.COLLECTION_UPDATE,params),
        post: body
    }
    return prepareRequest(config,request,true);
}
async function deleteCollection(params, body, urlSegments) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(COLLECTION_API_URL_LIST.COLLECTION_DELETE,params,urlSegments),
        post: body
    }
    return prepareRequest(config,request,true);
}
async function approveCollection(params, body, urlSegments) {
    let config= {
        headers:{
            Authorization: "Bearer " + store.state.auth.token
        }
    };
    let request = {
        method: "POST",
        url: setParamsToURL(COLLECTION_API_URL_LIST.COLLECTION_APPROVE,params,urlSegments),
        post: body
    }
    return prepareRequest(config,request,true);
}
export {
    getAllCollections,
    getSingleCollection,
    addCollection,
    updateCollection,
    deleteCollection,
    approveCollection,
}